import {Injectable} from '@angular/core';
import {LocalStorageKeys} from './local-storage.enum';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})

export class LocalStorageService {

  clear(key: LocalStorageKeys): void {
    const prodKey = `${key}_${environment.production ? 'prod' : 'dev'}`;
    localStorage.removeItem(prodKey as string);
  }

  read<T>(key: LocalStorageKeys): T {
    const prodKey = `${key}_${environment.production ? 'prod' : 'dev'}`;
    return JSON.parse(localStorage.getItem(prodKey as string)) as T;
  }

  write<T>(key: LocalStorageKeys, value: T): void {
    const prodKey = `${key}_${environment.production ? 'prod' : 'dev'}`;
    localStorage.setItem(prodKey as string, JSON.stringify(value));
  }

  writeWithExpiry<T>(key: LocalStorageKeys, value: T, ttl: any): void{
    const prodKey = `${key}_${environment.production ? 'prod' : 'dev'}`;
    const now = new Date();
    const item = {
      value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(prodKey, JSON.stringify(item));
  }

  readWithExpiry<T>(key: LocalStorageKeys): T {
    const prodKey = `${key}_${environment.production ? 'prod' : 'dev'}`;
    const itemStr = localStorage.getItem(prodKey);
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(prodKey);
      return null;
    }
    return item.value;
  }
}
